// Project.jsx
import React from 'react';
import { works } from "../data/works";
import { Loading } from './Loading';

export const Project = () => {
  return (
    <Loading dataSource={works}>
      <ProjectContent />
    </Loading>
  );
};

const ProjectContent = ({ data }) => {
  return (
    <div className="page page-work">
      <h1>{data.name}</h1>
      <div className="mask">
        <img src={`../images/${data.id}.png`} alt={data.name} />
      </div>

      <p>Tecnologías usadas: {data.technologies}</p>
      <p>{data.description}</p>
      <p>Categoría: {data.categories}</p>
      <a href={`https://${data.url}`} target="_blank" rel="noreferrer">Ir al sitio</a>
    </div>
  );
};
